import Vue from 'vue'
import axios from 'axios'
import {ServerTable, ClientTable, Event} from 'vue-tables-2'

Vue.use(ServerTable, {

    requestFunction: function (data) {
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
        }.bind(this));
    }

}, true)

Vue.use(ClientTable, {
    texts: {
        count: '{from} -tól {to} -ig rekordok mtatása |{count} rekord|Egy rekord',
        filterPlaceholder: 'Keresés',
        limit: 'Rekordok:',
        page: 'Oldal:',
        noResults: 'Nincs rekord',
        filterBy: 'Filter {column} oszlop szerint',
        loading: 'Töltés...',
        defaultOption: 'Válassz {column}',
        columns: 'Oszlopok',

    }
}, true)



// WEBPACK FOOTER //
// ./src/plugins/tables.js